import { V2_WEB_OFFER } from '../../../v2/shared/services/v2WebOffer';

// How the public website describes Routora Pro, the personal subscription
// sold after launch. The price, trial and allowance come from the same offer
// the app's paywall shows. Every claim here was checked against the live
// product: the web importer takes CSV only (an Excel workbook is saved as CSV
// first), the app hands off to Google Maps, Apple Maps or Waze, and a
// completed route downloads as a PDF report. General route sharing, direct
// Excel upload and mobile spreadsheet import are not offered, so they are
// never promised.
export const ROUTORA_PRO = Object.freeze({
  name: 'Routora Pro',
  price: V2_WEB_OFFER.price,
  priceSuffix: '/ month',
  trial: `${V2_WEB_OFFER.trialDays}-day free trial for first-time subscribers`,
  trialDays: V2_WEB_OFFER.trialDays,
  dailyStops: V2_WEB_OFFER.dailyStops,
  allowance: `Optimize up to ${V2_WEB_OFFER.dailyStops} stops a day`,
  features: Object.freeze([
    'Plan on the web, run the route in the app',
    'Import stops from a CSV, including Excel exports',
    'Photos, notes and results at every stop',
    'A PDF report for each completed route',
  ]),
});
